import axios from '../axios'

export const selectPage = (data) => {
    return axios({
        url: '/admin/platformSubject/selectPage',
        method: 'post',
        data
    })
}
export const insert = (data) => {
    return axios({
        url: '/admin/platformSubject/insert',
        method: 'post',
        data
    })
}
export const update = (data) => {
    return axios({
        url: '/admin/platformSubject/update',
        method: 'post',
        data
    })
}

export const batchEnable = (data) => {
    return axios({
        url: '/admin/platformSubject/batchEnable',
        method: 'post',
        data
    })
}

export const batchDisabled = (data) => {
    return axios({
        url: '/admin/platformSubject/batchDisabled',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/admin/platformSubject/batchDelete',
        method: 'post',
        data
    })
}

export const initCreate = (data) => {
    return axios({
        url: '/admin/platformSubject/initCreate',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/platformSubject.js